import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Button from '@atlaskit/button/standard-button';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { async_softwareReleasesLaunchCard_AsyncVersionStatus$key } from '@atlassian/jira-relay/src/__generated__/async_softwareReleasesLaunchCard_AsyncVersionStatus.graphql';
import { lazy } from '@atlassian/react-loosely-lazy';
import { GetCurrentStatusLabel, type VersionStatus } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyVersionStatus = lazy<typeof VersionStatus>(() =>
	import(/* webpackChunkName: "async-version-status" */ './index').then(
		(module) => module.VersionStatus,
	),
);

type Props = {
	jiraVersion: async_softwareReleasesLaunchCard_AsyncVersionStatus$key;
};

export const AsyncVersionStatus = ({ jiraVersion }: Props): React.JSX.Element => {
	const version = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment async_softwareReleasesLaunchCard_AsyncVersionStatus on JiraVersion {
				status @required(action: THROW)
				...versionStatus_softwareReleasesLaunchCard
			}
		`,
		jiraVersion,
	);

	return (
		<Placeholder
			name="version-status"
			fallback={
				<SkeletonContainer>
					<Button>{GetCurrentStatusLabel(version.status)}</Button>
				</SkeletonContainer>
			}
		>
			<LazyVersionStatus jiraVersion={version} />
		</Placeholder>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonContainer = styled.div({
	display: 'flex',
	width: '100%',
	height: '40px',
});
